<template>
    <div class="FundoAneis" :style="CoresAneis">
      <div class="bolinha1"></div>
      <div class="bolinha2"></div>
      <div class="bolinha3"></div>
      <div class="bolinha4"></div>
      <div class="ligacao1"></div>
      <div class="ligacao2"></div>
      <div class="ligacao3"></div>
      <div class="ligacao4"></div>
      <div class="ligacao5"></div>
  </div>
</template>

<script>
export default {
name: "AneisEffect",
		data() {
			return {
                backgroundAneis: "#000",
                CorAneis: "#008fac"
            };
		},
	components: {},
    props: ["configAneis"],
	computed: {
		CoresAneis: function () {
			return [
                {"--aneis-background-color": this.backgroundAneis},
                {"--aneis-color": this.CorAneis}
            ];
		}
    },
    methods: {
        setConfiguracaoInicial() {
            if(this.configAneis) {
                if (this.configAneis.backgroundAneis) {
					this.backgroundAneis = this.configAneis.backgroundAneis;
				}
				if (this.configAneis.CorAneis) {
					this.CorAneis = this.configAneis.CorAneis
				}
            }
        }
    },
    created() {
            this.setConfiguracaoInicial();
    }
};
</script>

<style>
.FundoAneis {
    position: relative;
    width: 100%;
    height: 100%;
    background: var(--aneis-background-color);
    margin: auto;
}

.bolinha1 {
    position: absolute;
    top: 10%;
    left: 27.5%;
    width: 45%;
    height: 15%;
    border: solid 2px var(--aneis-color);
    border-radius: 50%;
}
.bolinha2 {
    position: absolute;
    top: 30%;
    left: 27.5%;
    width: 45%;
    height: 15%;
    border: solid 2px var(--aneis-color);
    border-radius: 50%;
}
.bolinha3 {
    position: absolute;
    top: 50%;
    left: 27.5%;
    width: 45%;
    height: 15%;
    border: solid 2px var(--aneis-color);
    border-radius: 50%;
}
.bolinha4 {
    position: absolute;
    top: 70%;
    left: 27.5%;
    width: 45%;
    height: 15%;
    border: solid 2px var(--aneis-color);
    border-radius: 50%;
}
.ligacao1 {
    position: absolute;
    top: 2%;
    left: 45.53%;
    width: 0%;
    height: 8%;
    border: solid 1px var(--aneis-color);
}
.ligacao2 {
    position: absolute;
    top: 25%;
    left: 45.53%;
    width: 0%;
    height: 6%;
    border: solid 1px var(--aneis-color);
}
.ligacao3 {
    position: absolute;
    top: 45%;
    left: 45.53%;
    width: 0%;
    height: 6%;
    border: solid 1px var(--aneis-color);
}
.ligacao4 {
    position: absolute;
    top: 65%;
    left: 45.53%;
    width: 0%;
    height: 6%;
    border: solid 1px var(--aneis-color);
}
.ligacao5 {
    position: absolute;
    top: 85%;
    left: 45.53%;
    width: 0%;
    height: 8%;
    border: solid 1px var(--aneis-color);
}
</style>